export default __webpack_public_path__ + "static/media/slider3it.cd3c94ad.jpg";